export function turboSubmitOk(buttonOrForm: HTMLFormElement | HTMLButtonElement): Promise<boolean> {
  const form = buttonOrForm instanceof HTMLFormElement ? buttonOrForm : buttonOrForm.form;
  const button = buttonOrForm instanceof HTMLButtonElement ? buttonOrForm : undefined;

  return new Promise((resolve) => {
    const onBeforeFetchResponse = (event: Event) => {
      form.removeEventListener("turbo:before-fetch-response", onBeforeFetchResponse);
      const fetchResponse = (event as CustomEvent<{ fetchResponse?: { response?: Response } }>).detail
        .fetchResponse;
      resolve(!!fetchResponse?.response?.ok);
    };
    form.addEventListener("turbo:before-fetch-response", onBeforeFetchResponse);
    form.requestSubmit(button);
  });
}